import React from 'react';

export function getFilterDataTooltipMessage(name, description) {
  const containerStyle = {
    lineHeight: '1.5'
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    fontSize: '14px'
  };

  const descriptionStyle = {
    marginBottom: '14px',
    fontSize: '12px'
  };

  return (
    <div style={containerStyle}>
      <span style={labelStyle}>{name}</span>
      {description && <span style={descriptionStyle}>{description}</span>}
    </div>
  );
}

export function getStatusTooltipMessage(filter) {
  // filter should be etiher BOB or Member
  const messages = (() => {
    if (filter === 'Member') {
      return {
        Active:
          'Policy is currently in force and premium payments are up to date.',
        Inactive:
          'Policy is no longer in effect due to cancellation, lapse, or expiration.',
        'At Risk':
          'Client has missing or late premium payments; policy may lapse if unresolved.',
        Pending:
          'Policy has been received by the carrier but not yet active; the effective date is in the future. This does not necessarily mean that the binder payment has been paid.'
      };
    }

    if (filter === 'BOB') {
      return {
        Dropped:
          'Policy was previously in your book of business but has been removed. Date below status indicates when it fell off.',
        'On BOB':
          'Policy is currently in your Book of Business and has not been removed.'
      };
    }
  })();

  const containerStyle = {
    fontSize: '14px',
    lineHeight: '1.5',
    marginBottom: '8px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '4px',
    display: 'block'
  };

  const descriptionStyle = {
    marginBottom: '12px'
  };

  const renderMessage = label => (
    <div key={label} style={containerStyle}>
      <span
        style={{
          ...labelStyle,
          color:
            label === 'Active' || label === 'On BOB'
              ? '#3dcc21'
              : label === 'Inactive' || label === 'Dropped'
              ? 'red'
              : label === 'At Risk'
              ? 'orange'
              : ''
        }}
      >
        {label}
      </span>
      <p style={descriptionStyle}>{messages[label]}</p>
    </div>
  );

  const labels = Object.keys(messages);
  return <div>{labels.map(label => renderMessage(label))}</div>;
}
